import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import {
  updateProps as updatePropsAction,
  clearStore as clearStoreAction,
  loadExistingConnections as loadExistingConnectionsAction,
  processPartners as processPartnersAction,
  getContractingPartners as getContractingPartnersAction,
  getContractRequest as getContractRequestAction,
} from '../../../../stores/contracting/send-to-partners/actions';
import { RaisedButton } from 'material-ui';
import SelectMethod from './select-method';
import ReviewPartners from './review-partners';
import ExistingPartners from './existing/container-existing';
import ImportFromEmail from './import-from-email';
import UploadFile from './upload-file';
import AddIndividually from './add-individually';
import LoadingOverlay from '../../../tc-ui/loading-overlay';
import { openUpgradeFrom as openUpgradeFromAction } from '../../../../stores/ui/components/upgrade/upgrade-actions';
import R from 'ramda';
import pluralize from 'pluralize';
import injectSheet from 'react-jss';

// Basic Account Partners Threshold
const basicNo = 20;
const propTypes = {
  sendToPartners: PropTypes.object,
  outstandingRequests: PropTypes.array,
  updateProps: PropTypes.func,
  loadExistingConnections: PropTypes.func,
  clearStore: PropTypes.func,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  locationId: PropTypes.string,
  processPartners: PropTypes.func,
  validityCheckFn: PropTypes.func,
  getContractingPartners: PropTypes.func,
  billingPlan: PropTypes.string,
  companyType: PropTypes.string,
  getContractRequest: PropTypes.func,
  openUpgradeFrom: PropTypes.func,
  classes: PropTypes.object,
};
const styles = {};

class SendToPartners extends Component {
  componentWillMount() {
    const { sendToPartners, loadExistingConnections, billingPlan, getContractingPartners, startDate, endDate, companyType, locationId, getContractRequest } = this.props;
    if (R.isEmpty(sendToPartners.partnersToSendTo)) {
      loadExistingConnections();
      if (billingPlan === 'basic') getContractingPartners(startDate, endDate);
      if (companyType === 'Supplier') getContractRequest({ startDate, endDate, locationId });
    }
  }
  shouldComponentUpdate(nextProps) {
    const propKeys = R.keys(propTypes);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps));
  }
  render() {
    const {
      sendToPartners,
      updateProps,
      validityCheckFn,
      processPartners,
      billingPlan,
      companyType,
    } = this.props;

    const sharedProps = {
      updateProps,
      processPartners,
      clearReducer: this.props.clearStore,
    };

    const actionItems = [
      {
        cyData: 'selectFromConnections',
        text: 'Select from connections',
        icon: 'tc-icon-user',
        func: () => updateProps({
          addPartnersMethod: 'fromConnections',
          showSelectFromPartnersDialog: true,
        }),
      },
      {
        cyData: 'importFromEmail',
        text: 'Import from email',
        icon: 'tc-icon-email',
        func: () => updateProps({
          addPartnersMethod: 'emailImport',
          showEmailImportDialog: true,
        }),
      },
      {
        cyData: 'uploadAFile',
        text: 'Upload a file',
        icon: 'tc-icon-insert-drive-file',
        func: () => updateProps({
          addPartnersMethod: 'uploadFile',
          showUploadFileDialog: true,
        }),
      },
      {
        cyData: 'addIndividually',
        text: 'Add individually',
        icon: 'add-circle-icon',
        func: () => updateProps({
          addPartnersMethod: 'addIndividually',
          showAddIndividuallyDialog: true,
        }),
      },
    ];

    const getSelectedMethod = () => {
      switch (sendToPartners.addPartnersMethod) {
        case 'fromConnections':
          return <ExistingPartners {...sharedProps} />;
        case 'emailImport':
          return <ImportFromEmail {...sharedProps} />;
        case 'uploadFile':
          return <UploadFile {...sharedProps} />;
        case 'addIndividually':
          return <AddIndividually {...sharedProps} />;
        default:
          return (<span/>);
      }
    };
    const contractingPartnersLength = (sendToPartners.contractingPartners || []).filter(obj => obj.paidBy === 'Supplier').length;
    const noneSelected = !(sendToPartners.partnersToSendTo && sendToPartners.partnersToSendTo.length);
    return (
      <div>
        <div>
          {
            // Basic Account Partners Threshold
            Boolean(companyType === 'Supplier' && billingPlan === 'basic' && contractingPartnersLength && contractingPartnersLength < basicNo) && (
              <div style={{ fontWeight: 'bold' }}>
                <div>{`You have used ${contractingPartnersLength}/${basicNo} of your free contracting partners under the Basic Plan.`}</div>
                <div>You will be able to send your contracts to {basicNo - contractingPartnersLength} additional {pluralize('partner', basicNo - contractingPartnersLength)}.</div>
              </div>
            )
          }
          {
            Boolean(companyType === 'Supplier' && billingPlan === 'basic' && contractingPartnersLength >= basicNo) && (
              <div style={{ fontWeight: 'bold' }}>
                <div>{`You have used ${contractingPartnersLength}/${basicNo} of your free contracting partners under the Basic Plan.`}</div>
                <div>In order to send your rates to all of your partners, you can
                  &nbsp;<RaisedButton label="upgrade" secondary onTouchTap={() => this.context.router.push('/upgrade')} />&nbsp;
                  to our Connected Plan.</div>
              </div>
            )
          }
          {
            noneSelected ?
              <SelectMethod
                updateProps={updateProps}
                addPartnersMethod={sendToPartners.addPartnersMethod}
                actionItems={actionItems}
              /> : <span/>
          }
          {Boolean(sendToPartners.addPartnersMethod) ? getSelectedMethod() : <span/>}
          {
            !noneSelected ?
              <ReviewPartners
                actionItems={actionItems}
                validityCheckFn={validityCheckFn}
                {...sharedProps}
              /> : <span/>
          }
        </div>
      <LoadingOverlay
        loading={sendToPartners.processingPartners || sendToPartners.loadingExisting || sendToPartners.gettingRequests}
        text="Checking partner validity, thanks for your patience..."
      />
      </div>
    );
  }
}

SendToPartners.propTypes = propTypes;
SendToPartners.contextTypes = {
  router: PropTypes.object.isRequired,
};
const mapStateToProps = ({ contracting, user }) => ({
  sendToPartners: contracting.sendToPartners.toJS(),
  billingPlan: user.get('billingPlan'),
  companyType: user.getIn(['user', 'type']),
});
const mapDispatchToProps = (dispatch, { startDate, endDate }) => ({
  updateProps: (payload) => dispatch(updatePropsAction(payload)),
  processPartners: payload => dispatch(processPartnersAction(payload, startDate, endDate)),
  clearStore: () => dispatch(clearStoreAction()),
  loadExistingConnections: () => dispatch(loadExistingConnectionsAction()),
  getContractingPartners: (...args) => dispatch(getContractingPartnersAction(...args)),
  getContractRequest: (...args) => dispatch(getContractRequestAction(...args)),
});

export default connect(mapStateToProps, mapDispatchToProps)(injectSheet(styles)(SendToPartners));



// WEBPACK FOOTER //
// ./src/app/components/contracting/generic-components/send-to-partners/container-send-to-partners.jsx